export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f169224f00ce9b0b5d6238991e9999f3d26c4e9de&name=fetchTypeahead!'